import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-packingTable",
  "use": "icon-packingTable-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-packingTable\">\n<rect x=\"22.475\" y=\"48.316\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#DAB866\" width=\"155.051\" height=\"103.367\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol